import React, { FC } from 'react';
import styled from 'styled-components';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

type Props = {
  register: any;
  name: string;
  dropdownItems: any[];
  setValue: any;
  trigger: any;
};
const FranchiseContacts: FC<Props> = ({ dropdownItems, name, register }) => {
  const disabled = dropdownItems.length === 0;
  return (
    <SelectWrapper>
      <Select name={name} ref={register} disabled={disabled}>
        <option value="">{disabled ? 'Select an office to see contacts' : 'Select a contact'}</option>
        {dropdownItems.map((item, index) => (
          <option key={index} value={item.id}>
            {item.title}
          </option>
        ))}
      </Select>
      <Chevron>
        <ExpandMoreIcon />
      </Chevron>
    </SelectWrapper>
  );
};

export default FranchiseContacts;

const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const Chevron = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--neutral-500);
  display: inline-flex;

  svg {
    font-size: 20px;
  }
`;

const Select = styled.select`
  width: 100%;
  height: 40px;
  padding: 0 36px 0 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--neutral-0);
  color: var(--mainText);
  font-family: inherit;
  font-size: 0.875rem;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover:not(:disabled) {
    border-color: var(--neutral-400);
  }

  &:focus {
    outline: none;
    border-color: var(--primary-600);
    box-shadow: var(--shadow-focus);
  }

  &:disabled {
    background: var(--neutral-100);
    color: var(--neutral-500);
    cursor: not-allowed;
  }
`;
